<template>
  <el-drawer title="组合铺货" :visible.sync="dialogVisible" :append-to-body="false" :wrapperClosable="false" class="edit-drawer" size="65%" @close="handleClose">
    <div class="drawer-container">
      <!-- 表单部分 -->
      <div v-if="formShow" class="form-part">
        <component
          :is="formPlatfrom + 'Form'"
          :ref="`${formPlatfrom}Form`"
          :form="form"
          :formData="form"
          :baseItemId="form.baseItemId"
          :shopsList="someFromMethodOpen.shops"
        />
      </div>
      <div v-else v-loading="!formShow" class="block-loading"></div>

      <div v-if="formShow" class="drawer-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">铺 货</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
/**
 * 组合铺货弹窗（最后一步的资料编辑页）
 * 1. 在此组件里组合出相应平台的类似detail接口数据
 * 2. 传入对应平台的Form表单进行编辑
 * 3. 编辑完后调组合铺货接口铺货
 */
import Helper from './utils/puhuoDialogHelper'
import { getPublishEntrance } from './utils/index'
import {groupProdsOnSelf} from '@/servers/prod/center/index.js'

import { mapActions, mapGetters, mapMutations} from "vuex";
import { cloneDeep } from 'lodash';
export default {
    name: "puhuoDialog",
    components: {
        ...Helper.getPlatformFormComps()
    },
    provide: {
        isGroupPuhuo: true
    },
    inject: {
        from: {
            default: null
        },
        supplierCompanyId: {
            default: null
        },
        pageId: {
            default: null
        }
    },
    data() {
        return {
            dialogVisible: false,

            formShow: false, // 当detail数据加载完成置为true来展示表单
            formPlatfrom: '', // 当前表单平台
            form: null,

            someFromMethodOpen: {} // 从method_open那来的需要存的一些东西
        }
    },
    computed: {
        ...mapGetters(['routerPrefix']),
    },
    methods: {
        ...mapActions(['publishSpeed']),
        ...mapMutations(['setCurrentPage']),
        async handleConfirm() {
            let data = await this.$refs[`${this.formPlatfrom}Form`].method_getFormData()
            // 若部分平台还要处理额外校验可在这里处理
            
            // 开始调接口铺货
            this.service_puhuo(data);

        },
        async service_puhuo(data) {
            if (!data) return false;
            let baseSkuIds = data.skuList.map(({id}) => id).filter(Boolean);
            const { shops, rowsData, source, closeFun, clearCart } = this.someFromMethodOpen;
            data.skuList = Helper.skuParamsFormat(source, data.skuList);
            const res = await groupProdsOnSelf({
                publishEntrance: getPublishEntrance(this.from),
                item: Helper.dataParamsFormat(source, data),
                shopIds: shops.map(({shopId}) => shopId),
                companyId: this.$store.getters.userInfo.companyId,
                baseItemIds: rowsData.map(({baseItemId}) => baseItemId),
                platform: source,
                supplierCompanyId: this.supplierCompanyId,
                baseSkuIds,
                clearCart
            })
            if (res) {
                // this.close();
                closeFun && closeFun();
                this.setCurrentPage(this.pageId ? this.pageId : `${this.routerPrefix}goods`);
                this.publishSpeed({publishType: 'PIECE_ITEM', resultVisible: true, platform: source, batchTaskId: source === 'fxg' ? res : ''});
                this.someFromMethodOpen.onSuccess?.();
            } else {
                this.$message({
                    type: 'error',
                    message: `组合铺货失败!`,
                });
            }
        },
        close() {
            this.dialogVisible = false;
        },
        handleClose() {
            Object.entries(this.$options.data()).forEach(([key, val]) => {
                this[key] = val
            })
        },
        /**
         * 生成表单详情数据
         */
        async genDetail({formData, specList, source}) {
            // 直接调接口获取详情数据
            let _sorce = source === '1688' ? 'alibaba' : source;
            let detail = null;
            if (this.from === 'supplierShop') {
                // 来自供销商小店的组合铺货
                let params = Helper.getPlatformInfoParams(formData, {isFromSupplierShop: true})[_sorce];
                params.companyId = this.supplierCompanyId;
                detail = await Helper.PLATFORM_INFO_API_SUPPLIER[_sorce](params);
            } else {
                detail = await Helper.PLATFORM_INFO_API[_sorce](Helper.getPlatformInfoParams(formData)[_sorce])
            }
            if (!detail) return false;

            if (['kuaishou'].includes(source)) {
                detail.outerId = formData.outerId   
            }
            return detail;
        },

        async method_open({
            source, // 当前平台
            formData, // 主商品信息
            specList, // 所选skuList
            shops, // 要铺货的店铺列表
            specNum, // 当前规格数量
            rowsData, // 所有选择的商品信息
            closeFun, // 前面弹窗的关闭方法
            onSuccess,
            clearCart
        } = {}) {
            this.dialogVisible = true;
            this.someFromMethodOpen = {
                shops, // 要铺货的店铺列表
                specNum, // 当前规格数量
                rowsData, // 所有选择的商品信息
                closeFun, // 前面弹窗的关闭方法
                source, // 当前平台
                onSuccess,
                clearCart
            }
            // 开始生成类似detail接口的数据
            let detail = await this.genDetail({formData, specList, source});
            // 替换详情数据中的specifications 及 skuList
            let newSpecifications = Helper.generateSpecifications(specList, formData);
            let newSkuList = Helper.generateSkulist(newSpecifications, specList, source);
            detail.specifications = newSpecifications;
            detail.skuList = newSkuList
            if (!detail) {
                this.$message.error('生成商品详情失败');
                this.dialogVisible = false;
                return ;
            }
            this.form = detail;
            this.formShow = true;
            this.formPlatfrom = source === '1688' ? 'alibaba' : source;
        },
    }
}
</script>

<style lang="scss" scoped> 
.block-loading {
    min-height: 300px;
}
.edit-drawer {
    ::v-deep .el-drawer__body {
        overflow-y: scroll !important;
        flex: 1;
    }
}

.drawer-container {
    display: flex;
    flex-direction: column;
    min-height: 100%;

    .form-part {
        flex: 1;
        overflow-y: auto;
        padding-bottom: 16px;
    }

    .drawer-footer {
        position: sticky;
        bottom: 0;
        padding: 16px;
        border-top: 1px solid #EBEEF5;
        display: flex;
        justify-content: center;
        background: #fff;
        z-index: 1;
    }
}

</style>